module.exports = __webpack_public_path__ + "static/media/hashtag-nft-7.3af70484.jpg";